import React from 'react'
import { render } from 'react-dom'
import { BrowserRouter } from 'react-router-dom'
import { Provider } from 'react-redux'
import configureStore from 'redux/store'
import { configureTranslation } from 'lib/i18n'
import { serviceRouter } from 'routes'
import { ApolloClient } from 'apollo-client'
import { ApolloProvider } from 'react-apollo'
import { ApolloLink } from 'apollo-link'
import { InMemoryCache } from 'apollo-cache-inmemory'
import { createHttpLink } from 'apollo-link-http'
import Cookie from 'js-cookie'
import url from 'url'
import { createGraphqlInterface } from 'frontend_core/dist/api/graphql'
import RestClient from 'frontend_core/dist/rest/client'
import { Host } from 'frontend_core/dist/helpers/url'

window.i18n = configureTranslation(__SPM_TRANSLATION__)
delete window.__SPM_TRANSLATION__

window.manifest = __SPM_MANIFEST__
delete window.__SPM_MANIFEST__

const preloadedState = window.__SPM_PRELOADED_STATE__
delete window.__SPM_PRELOADED_STATE__

const errorStatus = window.__SPM_ERROR_STATUS__
delete window.__SPM_ERROR_STATUS__

// server side rendering flag turns off
preloadedState.config.SSR = false
const config = preloadedState.config
const httpLink = createHttpLink({
  uri: `${config.SPM_GRAPHQL_API_HOST}/graphql`,
})
const apiHeaders = createGraphqlInterface({ config }).headers

const middlewareLink = new ApolloLink((operation, forward) => {
  operation.setContext({
    headers: apiHeaders,
  })
  return forward(operation)
})
const link = middlewareLink.concat(httpLink)
const defaultOptions = {
  query: {
    fetchPolicy: 'network-only',
  },
}

const apolloClient = new ApolloClient({
  ssrMode: false,
  link,
  cache: new InMemoryCache().restore(window.__SPM_APOLLO_STATE__),
  defaultOptions,
})

const store = configureStore(preloadedState)
const AppRoute = serviceRouter(config.SERVICE, config.SSR, errorStatus)

RestClient.accessToken = Cookie.get('sm_at')
RestClient.apiHost = config.SPM_REST_API_HOST
RestClient.spmApiVersion = config.SPM_REST_API_VERSION
RestClient.apiKey = config.SPM_REST_API_KEY

const isDevelopment = config.ENV === 'development'

Host.configure(config, isDevelopment)

// ServiceWorkerの登録
if (!isDevelopment && 'serviceWorker' in navigator) {
  navigator.serviceWorker
    .register('/serviceWorker.js')
    .then(registration => {
      // Keenにイベントを飛ばす
      registration.update()
    })
    .catch(err => {
      console.log('ServiceWorker registration failed: ', err)
    })
}

// Web Pushを始める時にコメントイン
// const OneSignal = window.OneSignal || []
// OneSignal.push(function() {
//   OneSignal.init({
//     appId: config.ONE_SIGNAL_APP_ID,
//   })
// })

render(
  <ApolloProvider client={apolloClient}>
    <Provider store={store}>
      <BrowserRouter>
        <AppRoute />
      </BrowserRouter>
    </Provider>
  </ApolloProvider>,
  document.getElementById('js-root'),
)



// WEBPACK FOOTER //
// ./src/assets/packs/client.js